import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Environments
import { environment } from '@environments/environment';

const EXTEND_TERM_ROUTE_CONSTANT = 'extend-term/';
const VALUE_TO_PAY_ROUTE_CONSTANT = 'value-to-pay';
const RENEGOTIATE_LOAN_ROUTE_CONSTANT = 'renegotiate-loan/';
@Component({
  selector: 'app-active-credits-list',
  templateUrl: './active-credits-list.component.html',
})
export class ActiveCreditsListComponent implements AfterViewInit {
  @ViewChild('creditListRef', { static: false }) public activeCreditsListComponent: ElementRef;

  public isLoading: boolean;
  private readonly unSubscribe$: Subject<void>;

  constructor(private readonly webComponentService: WebcomponentsService, private readonly router: Router) {
    this.isLoading = false;
    this.unSubscribe$ = new Subject();
  }

  public ngAfterViewInit(): void {
    this.renderCreditListWebComponente();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.complete();
    this.unSubscribe$.unsubscribe();
  }

  private renderCreditListWebComponente(): void {
    const creditList = this.activeCreditsListComponent.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          creditList.ngElementStrategy?.componentRef?.instance?.build();
        }
      },
    });
  }

  public onRedirectToExtendTerm(event: { detail: { novationTypeId: string; loanCode: number } }): void {
    const urlToRedirect =
      event.detail.novationTypeId === environment.novationTypeId.RNE
        ? RENEGOTIATE_LOAN_ROUTE_CONSTANT
        : EXTEND_TERM_ROUTE_CONSTANT;
    this.router.navigate([urlToRedirect, event.detail.loanCode], {
      queryParams: { novationTypeId: event.detail.novationTypeId },
    });
  }

  public onRedirectToPayment(event: { detail: { loanCode: number; novationTypeId: string } }): void {
    this.router.navigate([VALUE_TO_PAY_ROUTE_CONSTANT, event.detail.loanCode], {
      queryParams: { novationTypeId: event.detail.novationTypeId },
    });
  }
}
